import React, { useState } from "react";
import styles from "./ContactUsForm.module.css";
// import {Map, GoogleApiWrapper} from 'google-maps-react';

const ContactUsForm = () => {
  const [formContent, setFormContent] = useState({});

  const handleChange = (event) => {
    const { value, name } = event.target;

    setFormContent((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <>
      <div className={`container ${styles.contain} overflow-hidden`}>
        <p data-aos="fade-up" className={`${styles.heading} mx-auto`}>
          We&apos;d Love to Hear From You
        </p>

        <div className="row">
          <div className="col-md-4" data-aos="fade-right">
            <p className={styles.head}>Address</p>
            <p className={styles.content}>
              Maru hity, Pyafal<br></br>Kathmandu, Nepal
            </p>
          </div>

          <div className="col-md-4" data-aos="fade-up" data-aos-offset="100">
            <p className={styles.head}>Contact</p>
            <p className={styles.content}>Mobile : +00 123 456 78</p>
            <p className={styles.content}>Phone : +00 123 678 90</p>
            <p className={styles.content}>Email: aminutesnooker@gmail.com</p>
          </div>

          <div className="col-md-4" data-aos="fade-left" data-aos-offset="70">
            <p className={styles.head}>Openings</p>
            <p className={styles.content}>Monday - Friday: 09:00 - 20:00</p>
            <p className={styles.content}>
              Sunday &amp; Saturday: 10:30 - 22:00
            </p>
          </div>
        </div>

        <p className={styles.email} data-aos="fade-up">
          You can email us
        </p>

        <div className="row">
          <div
            className="col-md-6"
            data-aos="fade-right"
            style={{ textAlign: "left" }}
          >
            <input
              placeholder="Your Name"
              name="name"
              value={formContent.name}
              onChange={handleChange}
              className={styles.input}
              type="text"
            />

            <input
              placeholder="Email"
              name="email"
              value={formContent.email}
              onChange={handleChange}
              className={styles.input}
              type="email"
            />

            <input
              name="subject"
              placeholder="Subject"
              value={formContent.subject}
              onChange={handleChange}
              className={styles.input}
              type="text"
            />
            <div data-aos="fade-left" style={{ textAlign: "left" }}>
              <textarea
                name="message"
                placeholder="Your Message"
                value={formContent.message}
                onChange={handleChange}
                className={`${styles.input} ${styles.msg}`}
                type="text"
              />
              <div style={{ textAlign: "left" }}>
                <button className={`btn custom_btn ${styles.btn}`}>SEND</button>
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d883.0994279654573!2d85.3053269!3d27.7050042!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb19007886c19d%3A0x2c5cbcb5f1c49728!2sA%20Minute%20Snooker%20%26%20Sports%20Bar!5e0!3m2!1sen!2snp!4v1704558960826!5m2!1sen!2snp"
              width="640"
              height="480"
            ></iframe>
          </div>
        </div>
      </div>

      {/* <div>
                <Map
                    google={this.props.google}
                    style={{width:'100%', height:'50%'}}
                    zoom={14}
                    initialCenter={
                        {
                            lat: 23.760374,
                            lng: 90.411643
                        }
                    }
                />
            </div> */}
    </>
  );
};

export default ContactUsForm;
